import {Observable} from 'rxjs/internal/Observable';
import {Injectable} from '@angular/core';
import {UserService} from './user.service';
import {of} from 'rxjs/internal/observable/of';
import {catchError, tap} from 'rxjs/operators';

declare var r: any;
@Injectable({ providedIn: 'root' })
export class RefersionService {
    constructor(private userService: UserService) {}

    private hasRefersionClick(): boolean {
        const rfsnId = localStorage.getItem('rfsn_v4_id');
        return !!rfsnId && rfsnId !== 'null';
    }

    public sendCheckoutEvent(cartId: string): void {
        if (!this.hasRefersionClick()) {
            return;
        }

        const rfsn = {
            cart: cartId,
            id: localStorage.getItem('rfsn_v4_id'),
            url: window.location.href,
            aid: localStorage.getItem('rfsn_v4_aid'),
            cs: localStorage.getItem('rfsn_v4_cs'),
        };

        r.sendCheckoutEvent(rfsn.cart, rfsn.id, rfsn.url, rfsn.aid, rfsn.cs);
    }

    /** Ensure the user has a cartId stored in your DB (one-time). */

    public ensureCartId(userCartId?: string | null, force = false): Observable<string | undefined> {
        if (!force && !this.hasRefersionClick()) {
            return of(undefined);
        }

        const cartId = userCartId ?? this.genUniqueId();
        this.sendCheckoutEvent(cartId);

        if (userCartId) {
            return of(cartId);
        }

        return this.userService.updateCartId(cartId).pipe(
            catchError((e) => {
                console.error('updateCartId failed:', e);
                return of(cartId);
            })
        );
    }

    private genUniqueId(): string {
        const dateStr = Date.now().toString(36);
        const randomStr = Math.random().toString(36).substring(2, 8);
        return `${dateStr}-${randomStr}`;
    }
}
